import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconClose: React.FC<IconProps> = ({ width = 12, height = 12, color = 'currentColor' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 14 14"
            fill="none"
        >
            <path
                d="M1 13L13 1M1 1L13 13"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default IconClose;
